export class PrivacyFastTrackInfoTypeModel {
    constructor (data: any) {
        Object.assign(this, data);
    }
}
